import { configureStore } from '@reduxjs/toolkit';

import { isDevelopment } from '../config/config-env';
import reducers from './rootReducer';
import preloadedState from './defaultState';
import services, { Services } from 'api';

export const store = configureStore({
  reducer: reducers,
  devTools: isDevelopment,
  preloadedState,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      thunk: {
        extraArgument: {
          ...services,
        } as Services,
      },
      serializableCheck: false,
    }),
});

export default store;
